import {
    FETCH_BOOKING_LOCATION,
    FETCH_BOOKING_LOCATION_SUCCESS,
    FETCH_BOOKING_LOCATION_FAILED,
    STOP_LOCATION_FETCH,
    STORE_ADRESSES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { query, onValue, set, update, off, push, limitToLast } from "firebase/database";
import { getEffectiveUserRole } from './authactions';

export const saveTracking = (bookingId, location) => {
    const {
        trackingRef
    } = firebase;
    push(trackingRef(bookingId), location);
}

export const fetchBookingLocations = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: FETCH_BOOKING_LOCATION,
        payload: bookingId,
    });
    onValue(query(trackingRef(bookingId), limitToLast(1)),(snapshot) => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const locations = Object.keys(data)
                .map((i) => {
                    return data[i]
                });
            if (locations.length == 1) {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_SUCCESS,
                    payload: locations[0]
                });
            }
            else {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
                });
            }
        } else {
            dispatch({
                type: FETCH_BOOKING_LOCATION_FAILED,
                payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
            });
        }
    });
};

export const stopLocationFetch = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: STOP_LOCATION_FETCH,
        payload: bookingId,
    });
    off(trackingRef(bookingId));
}

let lastLocationSave = 0;

export const saveUserLocation = async (location, force = false) => {
    if (!location || location.lat == null || location.lng == null) return;
    const profile = store.getState()?.auth?.profile;
    if (profile && (getEffectiveUserRole(profile) !== 'driver' || profile.driverActiveStatus !== true)) {
        return;
    }
    const now = Date.now();
    if (!force && now - lastLocationSave < 2500) return; // throttle 2.5s
    lastLocationSave = now;

    const { auth, userLocationRef, singleUserRef } = firebase;
    const uid = auth?.currentUser?.uid || store.getState()?.auth?.profile?.uid;
    if (!uid) return;

    const locPayload = { lat: Number(location.lat), lng: Number(location.lng) };
    if (isNaN(locPayload.lat) || isNaN(locPayload.lng)) return;

    const isDriverActive = store.getState()?.auth?.profile?.driverActiveStatus === true;
    const userUpdatePayload = isDriverActive
        ? { location: locPayload, driverActiveStatus: true }
        : { location: locPayload };

    let sdkSuccess = false;
    if (auth?.currentUser && userLocationRef) {
        try {
            await set(userLocationRef(uid), locPayload);
            if (singleUserRef) {
                update(singleUserRef(uid), userUpdatePayload).catch(() => {});
            }
            sdkSuccess = true;
        } catch (_) {}
    }

    if (!sdkSuccess) {
        // Fallback REST via getValidAuthToken when auth.currentUser is not synced in SDK memory
        try {
            const { getValidAuthToken } = require("./authactions");
            let token = await getValidAuthToken();
            if (token) {
                const dbUrl = (firebase.config?.databaseURL || "https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app").replace(/\/$/, '');
                let res = await fetch(`${dbUrl}/locations/${uid}.json?auth=${token}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(locPayload)
                });
                if (res.status === 401 || res.status === 403) {
                    token = await getValidAuthToken(true);
                    if (token) {
                        res = await fetch(`${dbUrl}/locations/${uid}.json?auth=${token}`, {
                            method: "PUT",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(locPayload)
                        });
                    }
                }
                fetch(`${dbUrl}/users/${uid}.json?auth=${token}`, {
                    method: "PATCH",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(userUpdatePayload)
                }).catch(() => {});
            }
        } catch (restErr) {
            console.warn("[saveUserLocation] REST fallback error:", restErr?.message);
        }
    }
}

export const storeAddresses = (data) => (dispatch) => {
    dispatch({
        type: STORE_ADRESSES,
        payload: data,
    });
}